import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import Icon from 'components/shared/Icon'
import DropDownSearchMenu from 'components/layout/search/DropdownSearchMenu'
import SearchHelperContainer from 'redux/containers/components/layout/search/SearchHelperContainer'
import InfoHelperButtonContainer from 'redux/containers/components/layout/search/InfoHelperButtonContainer'

const SearchBox = ({
  currentSearchPhrase,
  displayName,
  searchTypeClasses,
  inputRef,
  hideNavigation
}) => {
  const [value, setValue] = useState(currentSearchPhrase)

  useEffect(() => {
    setValue(currentSearchPhrase)
  }, [currentSearchPhrase])

  return (
    <div className='relative bg-ghost-grey mhauto w-100 flex justify-between'>
      <div className='items-center flex grow-1 h3 h2-m'>
        <DropDownSearchMenu MenuListProps={{ ref: inputRef }} {...{ searchTypeClasses }} />
        <div className='relative bg-void-grey w0 grow-1 h-100'>
          <input
            placeholder={`Search ${displayName}`}
            onFocus={() => hideNavigation()}
            ref={inputRef}
            className='b--none bg-void-grey w-100 h-100 focus-outline-0 pl6 pr8 ml0'
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          <InfoHelperButtonContainer {...{ inputRef }} />
        </div>
      </div>
      <button className={cx('white w9 w8-m pointer z10 flex justify-center items-center', searchTypeClasses)}>
        <span><Icon name='icon-magnify' className='w7 vm' /></span>
      </button>
      <SearchHelperContainer />
    </div>
  )
}

export default SearchBox
